<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  role="status"
  aria-label="Loading"
  [style.height.rem]="size"
  [style.width.rem]="size"
  [class]="merge('bk-spinner', className)"
>
  <circle class="bk-spinner__track" cx="12" cy="12" r="9" />
  <path class="bk-spinner__arc" d="M12 3a9 9 0 0 1 9 9" />
</svg>
